import { Component, OnInit, EventEmitter, Output, SimpleChanges, Input, OnChanges,OnDestroy } from '@angular/core';
import { Subject, Observable, of, concat } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError, map } from 'rxjs/operators';
import { OpportunityService } from '../../services/opportunity.service';
import { CandidateService } from '../../services/candidate/candidate.service';
import { StatesDistrictsService } from '../states-districts/states-districts.service';
import 'rxjs/add/observable/forkJoin';
import { NgOption } from '@ng-select/ng-select';
import * as $ from 'jquery';

@Component({
  selector: 'app-job-filter',
  templateUrl: './job-filter.component.html',
  styleUrls: ['./job-filter.component.scss']
})
export class JobFilterComponent implements OnInit, OnChanges {
  @Output() SelectOpportunity: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() SelectLocation: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() SelectDistrict: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() CourseType: EventEmitter<any> = new EventEmitter<any>();
  @Output() SelectEstablishment: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Input() selectedLocation: any[];
  @Input() selectedDistrict: any[];
  @Input() selectedCoursesType;
  @Input() CoursesList: any[];

  @Output() SelectSector: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() SelectQualification: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() SelectGender: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() SelectPwd: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() stipendUpto: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() stipendFrom: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Input() genderList: any[];
  @Input() pwdList: any[];
  @Input() sectorsList: any[];
  @Input() qualicationList:any[]
  @Input() selectedGender;
  @Input() selectedPwd;
  @Input() selectedSectorType;
  @Input() selectedQualificationType;
  @Input() selectedStipendFrom;
  @Input() selectedStipendUpto;
  selectedOpportunities;
  selectedEstablishment;
  opportunites: Observable<any>;
  opportunityInput = new Subject<string>();
  loadingOpportunities = false;
  loadingLocation = false;
  locationInput = new Subject<string>();
  courseNameList: any;
  courseNameFilterList: any;

  districts;
  states;
  locationData: any[] = [];
  districtLocation: any[] = [];

  @Input() establishmentList: Observable<any>;
  opportunityInputs = new Subject<string>();

  constructor(
    private candidateService: CandidateService,
    private oppoService: OpportunityService,
    private statesDistrictsService: StatesDistrictsService
  ) {
  }

  ngOnInit() {
    this.loadLocationData();
    this.loadOpportunities();
    this.getCourses();
  }


  ngOnChanges(changes: SimpleChanges) {    
    if (changes && changes.selectedCoursesType && changes.selectedCoursesType.currentValue == null) {
      this.courseNameFilterList = this.courseNameList;
    }

  }

  ngOnDestroy() {
    // this.establishmentList.unsubscribe();
  }
  
  getEstList() {
    console.log('calling keypress getEstList');
    this.establishmentList = concat(
      of([]), // default items
      this.opportunityInputs.pipe(
        debounceTime(400),
        distinctUntilChanged(),
        tap(() => console.log()),
        switchMap(term => this.candidateService.getEstablishmentList(term).pipe(
          map(res => {
            if (term !== '') {
              const changedData = res['data'].map(d => {
                d.estName = d.establishment_name + ' - ' + d.id;
                return d;
              });
              return changedData;
            } else {
              return [];
            }
          }),
          catchError(() => of([])), // empty list on error
          tap(() => console.log())
        ))
      )
    );
  }

  getEstListMobile(eve) {
    let value:any 
    value = eve.target.value;

   this.candidateService.getEstablishmentList(value).subscribe(responseList => {
        if (value !== '') {
          const changedData = responseList['data'].map(d => {
            d.estName = d.establishment_name + ' - ' + d.id;
            return d;
          });
          this.establishmentList = changedData;
          return changedData;
        } else {
          return [];
        }
      });

  }

  private loadOpportunities() {
    this.opportunites = concat(
      of([]), // default items
      this.opportunityInput.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => this.loadingOpportunities = true),
        switchMap(term => this.candidateService.getTradePrefList(term).pipe(
          map(res => {
            return res;
          }),
          catchError(() => of([])), // empty list on error
          tap(() => this.loadingOpportunities = false)
        ))
      )
    );
  }

  getCourses(searchTerm?) {
    this.oppoService.searchApprovedCourses(searchTerm).subscribe(res => {
      this.courseNameList = res['data'];
      this.courseNameFilterList = res['data'];
    });
  }

  private loadLocationData() {
    Observable.forkJoin([
      this.statesDistrictsService.states(),
      this.statesDistrictsService.allDistricts()]).subscribe(responseList => {
        this.states = responseList[0].data.map(ele => {
          const o = Object.assign({}, ele);
          o.type = 'state';
          return o;
        });
        this.districts = responseList[1].data.map(ele => {
          const o = Object.assign({}, ele);
          o.type = 'district';
          return o;
        });
        this.locationData = this.states.concat(this.districts);
      });
  }

  // private loadDistricts(state) {

  //   const stateId = state[0]['id'];
  //   setTimeout(() => {
  //     this.statesDistrictsService.districts(stateId).subscribe(responseList => {
  //       this.districtLocation = responseList.data.map(ele => {
  //         const o = Object.assign({}, ele);
  //         o.type = 'district';
  //         return o;
  //       });
  //     });
  //   }, 650);
  // }

  public onSelectChangeOpportunity() {

    this.SelectOpportunity.emit(this.selectedOpportunities);
    setTimeout(() => this.selectedOpportunities = undefined, 100);
  }

  public onSelectChangeLocation() {
    this.SelectLocation.emit(this.selectedLocation);
    // this.loadDistricts(this.selectedLocation);
  }

  public onSelectChangeGender() {
    console.log(this.selectedGender)
    this.SelectGender.emit(this.selectedGender);
  }

  public onSelectChangePwd() {
    console.log(this.selectedPwd)
    this.SelectPwd.emit(this.selectedPwd);
  }

  public enteredStipendUpto(){
    this.stipendUpto.emit(this.selectedStipendUpto)
  }

  public enteredStipendFrom(){
    console.log(this.selectedStipendFrom)
    this.stipendFrom.emit(this.selectedStipendFrom)
  }

  public onSelectChangeDistrict() {
    this.SelectDistrict.emit(this.selectedDistrict);
  }

  numberOnly(evt) {
    evt = (evt) ? evt : window.event;
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && evt.key !== 'Backspace') {
      return false;
    }
    return true;
  }
  
  public onSelectChangeEstablish(){
    this.SelectEstablishment.emit(this.selectedEstablishment);
    setTimeout(() => this.selectedEstablishment = undefined, 100);
  }

  public onSelectChangeSector(){
    console.log(this.selectedSectorType)
    this.SelectSector.emit(this.selectedSectorType);
  }

  public onSelectChangeQualification(){
    console.log(this.selectedQualificationType)
    this.SelectQualification.emit(this.selectedQualificationType);
  }

  public onSelectCourseType() {
    this.CourseType.emit(this.selectedCoursesType);
    // this.courseNameFilterList = [];
    if (this.selectedCoursesType) {
      this.courseNameList.forEach(result => {
        if (result.type == this.selectedCoursesType.value) {
          this.courseNameFilterList.push(result);
        }
      });
    } else {
      this.courseNameFilterList = this.courseNameList;
    }
  }

}

